import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { ScrollView, View, Platform, Keyboard } from 'react-native';
import { ComponentType, WebFormItem } from './WebFormItem';
import { Popup } from '../../Popup/rn';
import { useTracking } from '../../../hooks/rn/useTracking';
import styles from './style';
import { useLocale } from '../../LocaleProvider/rn';
import { TRACKING_TARGET } from '../../../utils/tracking/constants';
import { isValidValue } from './config';
export var ModeType;
(function (ModeType) {
  ModeType[ModeType["Edit"] = 0] = "Edit";
  ModeType[ModeType["Checking"] = 1] = "Checking";
  ModeType[ModeType["View"] = 2] = "View";
  ModeType[ModeType["EditItem"] = 3] = "EditItem";
})(ModeType || (ModeType = {}));
export var ValidateStatusType;
(function (ValidateStatusType) {
  ValidateStatusType["Validating"] = "validating";
  ValidateStatusType["Success"] = "success";
  ValidateStatusType["Error"] = "error";
})(ValidateStatusType || (ValidateStatusType = {}));
export var FormContext = /*#__PURE__*/React.createContext({
  validateStatus: ValidateStatusType.Success,
  formValidateStatus: {},
  handleFormItemValidate: function handleFormItemValidate() {}
});
export var WebForm = function WebForm(props) {
  var _ref = props || {},
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    title = _ref.title,
    mode = _ref.mode,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    onSubmit = _ref.onSubmit,
    _ref$errList = _ref.errList,
    errList = _ref$errList === void 0 ? [] : _ref$errList,
    selectItem = _ref.selectItem,
    trackingData = _ref.trackingData;
  var _useLocale = useLocale(),
    trans = _useLocale.trans; // 表单 Duration 上报

  var _useTracking = useTracking({
      trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
        trackingtarget: TRACKING_TARGET.closeWebform
      })
    }),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitLoading = _useState2[0],
    setSubmitLoading = _useState2[1];
  var _React$useState = React.useState(active),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    webformVisible = _React$useState2[0],
    setWebformVisible = _React$useState2[1];
  var _React$useState3 = React.useState(ModeType.View),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    currentMode = _React$useState4[0],
    setCurrentMode = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    currentEditItem = _React$useState6[0],
    setCurrentEditItem = _React$useState6[1];
  var _React$useState7 = React.useState({}),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    formData = _React$useState8[0],
    setFormData = _React$useState8[1];
  var _React$useState9 = React.useState(ValidateStatusType.Success),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    validateStatus = _React$useState10[0],
    setValidateStatus = _React$useState10[1];
  var _React$useState11 = React.useState({}),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    formValidateStatus = _React$useState12[0],
    setFormValidateStatus = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    stepStack = _React$useState14[0],
    setStepStack = _React$useState14[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    openTime = _useState4[0],
    setOpenTime = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollCount = _useState6[0],
    setScrollCount = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    scrollViewStyle = _useState8[0],
    setScrollViewStyle = _useState8[1];
  var focusInputTarget = useRef(null);
  useEffect(function () {
    setOpenTime(new Date().getTime());
  }, []);
  var handleScroll = function handleScroll() {
    setScrollCount(scrollCount + 1);
  };
  useEffect(function () {
    setWebformVisible(active);
  }, [active]);
  useEffect(function () {
    setCurrentMode(mode);
    setStepStack([mode]);
    setCurrentEditItem(selectItem || null);
  }, [mode, selectItem]);
  useEffect(function () {
    errList.forEach(function (param) {
      var isParamExist = items.find(function (item) {
        return item.name === param;
      });
      if (isParamExist) {
        setFormValidateStatus(_objectSpread(_objectSpread({}, formValidateStatus), {}, _defineProperty({}, param, 'Invalid Field')));
      }
    });
  }, [errList, items]);
  useEffect(function () {
    var newFormData = props.formData || {};
    setFormData(newFormData); // 初始化表单数据
  }, [props.formData]);
  var showItems = useMemo(function () {
    if (currentMode === ModeType.Edit) {
      return items.filter(function (item) {
        return item.inEditMode && ![ComponentType.WebFormOrder].includes(item.component);
      });
    } else {
      return items.filter(function (item) {
        return item.hidden !== true && ![ComponentType.WebFormOrder].includes(item.component);
      });
    }
  }, [currentMode, items]);
  var orderInfo = useMemo(function () {
    return items.filter(function (item) {
      if ([ComponentType.WebFormOrder].includes(item.component)) {
        if (!item.hidden) {
          if (item.inEditMode && currentMode === ModeType.Edit) {
            return true;
          } else if ([ModeType.View, ModeType.Checking].includes(currentMode)) {
            return true;
          }
        }
      }
      return false;
    });
  }, [items, currentMode]);
  useEffect(function () {
    if (showItems.length === 0 && currentMode === ModeType.Edit) {
      handleNext();
    }
  }, [showItems, currentMode]);
  useEffect(function () {
    if (currentMode === ModeType.Checking) {
      // 触发校验之前清空现在的状态
      setFormValidateStatus({}); // 要触发校验

      setValidateStatus(ValidateStatusType.Validating);
    }
  }, [currentMode]); // 解决键盘弹出被遮挡的情况

  useEffect(function () {
    // 订阅键盘弹出事件
    var keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', function () {
      var _focusInputTarget$cur;

      // 获取键盘的高度
      // const keyboardHeight = event.endCoordinates.height;
      if (focusInputTarget.current && (_focusInputTarget$cur = focusInputTarget.current) !== null && _focusInputTarget$cur !== void 0 && _focusInputTarget$cur.measure) {
        // 获取输入框的位置 给极端的情况做处理
        setTimeout(function () {
          var _focusInputTarget$cur2;
          (_focusInputTarget$cur2 = focusInputTarget.current) === null || _focusInputTarget$cur2 === void 0 ? void 0 : _focusInputTarget$cur2.measure(
          // @ts-ignore
          function (fx, fy, width, height, px, py) {
            // fx: number, fy: number, width: number, height: number, px: number, py: number
            // 如果输入框太高 就往下调整一点
            if (py < 50) {
              setScrollViewStyle({
                top: py < 0 ? 100 - py : py + 100
              });
            } else {
              setScrollViewStyle({});
            }
          });
        }, Platform.OS === 'android' ? 300 : 0);
      }
    });
    return function () {
      // 在组件卸载时取消事件订阅
      keyboardDidShowListener.remove();
    };
  }, []);
  var handleWebFormFocus = function handleWebFormFocus(e) {
    focusInputTarget.current = e === null || e === void 0 ? void 0 : e.target;
  };
  var handleWebFormBlur = function handleWebFormBlur() {
    setScrollViewStyle({});
  };
  var handleNext = function handleNext() {
    setStepStack([].concat(_toConsumableArray(stepStack), [ModeType.Checking]));
    setCurrentMode(ModeType.Checking);
  };
  var handleFormItemValidate = function handleFormItemValidate(data) {
    var newStatus = _objectSpread(_objectSpread({}, formValidateStatus), data);
    setFormValidateStatus(newStatus);
    var validateNotDone = showItems.find(function (item) {
      return newStatus[item.name] === ValidateStatusType.Validating || !newStatus[item.name];
    });
    if (!validateNotDone) {
      var _validateStatus = showItems.find(function (item) {
        return newStatus[item.name] && newStatus[item.name] !== ValidateStatusType.Success;
      });
      setValidateStatus(_validateStatus ? ValidateStatusType.Error : ValidateStatusType.Success);
    }
  };
  var showPrevIcon = useMemo(function () {
    if (currentMode === ModeType.EditItem) {
      return true;
    } else if (currentMode === ModeType.Checking) {
      var editItems = items.filter(function (item) {
        return item.inEditMode;
      });
      if (editItems.length > 0 && stepStack.length > 1) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }, [currentMode, items, stepStack]);
  var handlePrev = function handlePrev() {
    setCurrentEditItem(null);
    stepStack.pop();
    var prevMode = stepStack[stepStack.length - 1];
    if (prevMode !== undefined) {
      setCurrentMode(prevMode);
      setStepStack(_toConsumableArray(stepStack));
    } else {
      setCurrentMode(mode);
    }
  };
  var handleChange = function handleChange(value, key) {
    var newFormData = _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, key, value));
    setFormData(newFormData);
  };
  var handleClosePopup = function handleClosePopup() {
    // Close 表单的上报
    var endTime = new Date().getTime();
    Platform.OS === 'web' && trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {}), {}, {
        view_duration: ((endTime - openTime) / 1000).toFixed(0),
        webform_scrolls: scrollCount
      })
    }));
    if (props.onClose) {
      props.onClose({
        formData: formData,
        curMode: currentMode,
        selectItem: currentEditItem
      });
    } else {
      setWebformVisible(false);
    }
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 添加loading
              setSubmitLoading(true);
              _context.next = 3;
              return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(_objectSpread(_objectSpread({}, props), {}, {
                formData: formData
              }));
            case 3:
              setSubmitLoading(false);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var popupTitle = useMemo(function () {
    if (currentMode === ModeType.Edit) {
      return title;
    } else if (currentMode === ModeType.Checking) {
      return trans('webform_title_review_and_submit_request');
    } else if (currentMode === ModeType.View) {
      return trans('webform_form_details');
    } else if (currentMode === ModeType.EditItem && currentEditItem) {
      return currentEditItem.label;
    }
    return '';
  }, [currentMode, title, currentEditItem]);
  var disabledNext = useMemo(function () {
    return [].concat(_toConsumableArray(showItems), _toConsumableArray(orderInfo)).some(function (item) {
      return !isValidValue(formData[item.name], item);
    });
  }, [showItems, orderInfo, formData]);
  var handleSelectFormItem = function handleSelectFormItem(item) {
    // Select 组件和 WebformOrder 组件在这里添加点击上报？
    Platform.OS === 'web' && trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      trackingtarget: TRACKING_TARGET.webform,
      data: _objectSpread(_objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {}), {}, {
        field_name: item.label
      })
    }));
    setCurrentMode(ModeType.EditItem);
    setStepStack([].concat(_toConsumableArray(stepStack), [ModeType.EditItem]));
    setCurrentEditItem(item);
  };
  var disabledSubmit = useMemo(function () {
    return [].concat(_toConsumableArray(showItems), _toConsumableArray(orderInfo)).some(function (item) {
      return !isValidValue(formData[item.name], item);
    });
  }, [showItems, orderInfo, formData]);
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Popup, {
    title: popupTitle,
    contentStyle: styles.webformPopupContent,
    titlePosition: "center",
    maskClosable: false,
    showPrevIcon: showPrevIcon,
    onPrev: handlePrev,
    showCloseIcon: true,
    active: webformVisible,
    onClose: function onClose() {
      return handleClosePopup();
    },
    useKeyboardAvoidingView: Platform.OS === 'ios',
    modalContainerStyle: Platform.OS === 'web' ? {} : scrollViewStyle,
    footer: {
      buttons: [{
        hidden: currentMode !== ModeType.Edit,
        trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
          trackingtarget: TRACKING_TARGET.button,
          trackingdataTarget: {
            button_text: trans('webform_next_1/2')
          }
        }),
        styles: {
          containerStyle: {
            marginLeft: 8,
            marginTop: 8,
            marginBottom: 8,
            marginRight: 8,
            paddingBottom: 14,
            paddingTop: 14
          }
        },
        type: 'primary',
        disabled: disabledNext,
        text: trans('webform_next_1/2') || 'Next',
        onClick: handleNext
      }, {
        hidden: currentMode !== ModeType.Checking,
        type: 'primary',
        disabled: disabledSubmit,
        text: trans('webform_submit_2/2'),
        onClick: handleSubmit,
        loading: submitLoading,
        styles: {
          containerStyle: {
            marginLeft: 8,
            marginTop: 8,
            marginBottom: 8,
            marginRight: 8,
            paddingBottom: 14,
            paddingTop: 14
          }
        },
        trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
          trackingtarget: TRACKING_TARGET.button,
          trackingdataTarget: {
            button_text: trans('webform_submit_2/2')
          }
        })
      }]
    }
  }, /*#__PURE__*/React.createElement(ScrollView, {
    onScrollEndDrag: handleScroll
  }, /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      validateStatus: validateStatus,
      formValidateStatus: formValidateStatus,
      handleFormItemValidate: handleFormItemValidate
    }
  }, currentMode !== ModeType.EditItem ? /*#__PURE__*/React.createElement(React.Fragment, null, orderInfo.map(function (item, index) {
    return /*#__PURE__*/React.createElement(WebFormItem, _extends({}, item, {
      value: formData[item.name],
      trackingData: trackingData,
      onChange: function onChange(v) {
        return handleChange(v, item.name);
      },
      key: index,
      getCurRootTag: props.getCurRootTag,
      region: props.region,
      mode: currentMode,
      onSelectFormItem: function onSelectFormItem() {
        return handleSelectFormItem(item);
      },
      closeForm: function closeForm() {
        return handleClosePopup();
      }
    }));
  }), showItems.map(function (item, index) {
    return /*#__PURE__*/React.createElement(WebFormItem, _extends({}, item, {
      trackingData: trackingData,
      autoFocus: index === 0,
      value: formData[item.name],
      onChange: function onChange(v) {
        return handleChange(v, item.name);
      },
      getCurRootTag: props.getCurRootTag,
      key: index,
      region: props.region,
      mode: currentMode,
      onFocus: handleWebFormFocus,
      onBlur: handleWebFormBlur,
      closeForm: function closeForm() {
        return handleClosePopup();
      },
      onSelectFormItem: function onSelectFormItem() {
        return handleSelectFormItem(item);
      }
    }));
  })) : null, currentMode === ModeType.EditItem && currentEditItem ? /*#__PURE__*/React.createElement(WebFormItem, _extends({}, currentEditItem, {
    region: props.region,
    value: formData[currentEditItem.name],
    onChange: function onChange(v) {
      return handleChange(v, currentEditItem.name);
    },
    trackingData: trackingData,
    getCurRootTag: props.getCurRootTag,
    onPrev: handlePrev,
    mode: currentMode,
    closeForm: function closeForm() {
      return handleClosePopup();
    }
  })) : null))));
};